module.exports = __webpack_public_path__ + "img/Opened.bb47f605.svg";